import React, { FC, useRef, useState } from 'react';

import { message } from 'antd';
import { useRouter } from 'next/router';

import { getClient } from '@api/feedStream';
import type { AirdropDetailType } from '@api/index';
import { fetchClaimAirdropDetail, fetchSendAirdropDetail } from '@api/index';
import { AIRDROP_PATHS, MARKET_PATHS } from '@constants/paths';
import { useIsomorphicLayoutEffect } from '@lib/hooks';
import { IAirdropBox } from '@type/airdrop';
import { I18n } from '@utils/index';
import { GoBack } from '@widget/airdrop';
import { airdropReceiveStatus, airdropStatus } from '@widget/airdrop/constants';

import { useShare } from '../../hooks/useShareAirdrop';
import { BriefDetail } from '../brief';
import { List } from '../list';
import { LottieCover } from '../lottieCover';

import styles from './index.module.less';
export const AirDetail: FC = () => {
  const router = useRouter();
  const ref = useRef<HTMLDivElement>();
  const [airdropDetail, setAirdropDetail] = useState<AirdropDetailType>();
  const [lottieShow, setLottieShow] = useState<boolean>(false);
  const { isLoading, shareOpen } = useShare();
  const [userInfo, setUserInfo] = useState({})
  /** 空投激活成功 */
  const activeSuccess = () => {
    router.push(MARKET_PATHS.MARKET);
  }
  const onClickAirdrop = (props: any) => {
    const shareObj = {
      el: ref.current,
      ...props
    }
    switch (props.status) {
      case airdropReceiveStatus.activeSuccess:
        activeSuccess()
        break;
      case airdropStatus.drewing:
        shareOpen(shareObj)
        break;
      default:
        router.push(AIRDROP_PATHS.SEND);
        break
    }
  };
  // 获取空投详情
  const fetchAirdropDetail = async (id: string, receiveId?: string) => {
    // 判断是发出还是收到的空投
    const res = receiveId ? await fetchClaimAirdropDetail({ id, receiveId }) : await fetchSendAirdropDetail({ id })
    if (!res.success) {
      message.error(I18n.t(res.msgKey));
      return;
    }
    const list = res.obj;
    if (receiveId) {
      list.status = airdropReceiveStatus.activeSuccess;
    }
    setAirdropDetail(list);
  }
  // 获取用户信息
  const getUser = async () => {
    const userData = await getClient()
      .user(airdropDetail?.releaseCustomerId || '')
      .get({});
    const { result } = userData?.full as any || {}
    if (result) {
      setUserInfo(result)
    }
  }
  useIsomorphicLayoutEffect(() => {
    const { id, receiveId } = router.query;
    getUser();
    router.isReady && fetchAirdropDetail(id as string, receiveId as string);
  }, [router.query, airdropDetail?.releaseCustomerId]);
  return (
    <>
      <div className={styles.container} ref={ref}>
        <GoBack />
        <div className={styles.brief}>
          <div className={styles.cover} onMouseEnter={() => setLottieShow(true)} onTouchStart={() => setLottieShow(true)}>
            <LottieCover
              lottieShow={lottieShow}
              status={airdropDetail?.status}
              cover={airdropDetail?.cover as IAirdropBox}
              onFinish={() => setLottieShow(false)} />
          </div>
          <BriefDetail
            {...airdropDetail}
            status={airdropDetail?.status}
            onClickAirdrop={onClickAirdrop}
            userInfo={userInfo}
            loading = {isLoading}
          />
        </div>
        <List {...airdropDetail} />
      </div>
    </>
  );
};
